import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '@share/utils';
import { IMyProfileState, deleteUserCard } from '@share/store/slices';
import { ModalConfirmation } from '@components';
import { IUserCard } from '@share/common-types';
import { GetCreditCardImage } from '@utils';

interface IMapStateToProps {
  myProfileStore: IMyProfileState;
}

interface IMapDispatchToProps {
  deleteUserCard: (userCard: IUserCard, sucessCallBack: () => void) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps {
  card: IUserCard;
}

function PaymentCardComponent(props: IProps) {
  const { card, myProfileStore, deleteUserCard } = props;
  const { loadingCards } = myProfileStore;

  const [ showConfirmation, setShowConfirmation ] = useState(false);
  const [ selectedCard, setSelectedCard ] = useState(null);

  const handleConfirmDelete = () => {
    deleteUserCard(selectedCard, () => {
      setSelectedCard(null);
    });
    setShowConfirmation(false);
  }

  const year = card.expireDate?.substring(card.expireDate.length - 2);
  const month = card.expireDate?.substring(0, 2);

  return (
    <div className="card">
      <div className={`bg-${card.cardType === "visa" ? "primary" : "danger"} p-4 rounded-3`}>
        <div className="d-flex justify-content-between align-items-start">
          {GetCreditCardImage(card.cardType.toLowerCase(), true)}
          {/* <img
            className="w-40px"
            src={`assets/images/element/${brand.toLowerCase()}.svg`}
            alt=""
          /> */}
          <div className="dropdown">
            <a
              className="text-white"
              href="#"
              id={`creditcardDropdown-${card.cardType}`}
              role="button"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-expanded="false"
            >
              <svg width="24" height="24" fill="none">
                <circle
                  fill="currentColor"
                  cx="12.5"
                  cy="3.5"
                  r="2.5"
                ></circle>
                <circle
                  fill="currentColor"
                  opacity="0.5"
                  cx="12.5"
                  cy="11.5"
                  r="2.5"
                ></circle>
                <circle
                  fill="currentColor"
                  opacity="0.3"
                  cx="12.5"
                  cy="19.5"
                  r="2.5"
                ></circle>
              </svg>
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby={`creditcardDropdown-${card.cardType}`}
            >
              <li>
                <a
                  className="dropdown-item text-danger"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowConfirmation(true);
                    setSelectedCard(card);
                  }}
                >
                  <i className="bi bi-trash me-2 fw-icon"></i>
                  <FormattedMessage id="remove.card" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <h4 className="text-white mt-4">{card.cardNumber}</h4>
        <div className="d-flex justify-content-between text-white">
          <span><FormattedMessage id="valid.thru" />: {month}/{year}</span>
          <span><FormattedMessage id="cvv" />: {card.cvv}</span>
        </div>
      </div>

      <ModalConfirmation
          message="confirm.delete.credit.card"
          title="delete.credit.card"
          yesMessage="confirm.button"
          noMessage="cancel.button"
          visible={showConfirmation}
          disabled={loadingCards}
          onCancel={() => {
            if (!loadingCards) {
              setShowConfirmation(false);
              setSelectedCard(null);
            }
          }}
          onConfirm={handleConfirmDelete}
        />
    </div>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    myProfileStore: state.myProfileStore,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  deleteUserCard: (userCard: IUserCard, sucessCallBack: () => void) => {
    dispatch(deleteUserCard(userCard, sucessCallBack));
  }
});

const ComponentIntl = injectIntl(PaymentCardComponent);

const PaymentCard = connect(mapStateToProps, mapDispatchToProps)(withRouter(ComponentIntl));
export default PaymentCard;
